module.exports = __webpack_public_path__ + "media/images/banner1-b0c7a807488a08571691ba0888452348.png";